import {
  marketCountryIdFormat,
  marketIdFormat,
} from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";
import { marketWithCountriesOutput } from "./market";
import { marketDefinitionWireFields } from "./market-definition";

const countryCode = z
  .string()
  .regex(/^[A-Z]{2}$/, "Must be ISO 3166-1 alpha-2 uppercase");

const conflictResolution = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("archive_existing"),
    conflictMarketId: z.string(),
  }),
  z.object({ kind: z.literal("remove_region"), conflictMarketId: z.string() }),
  z.object({ kind: z.literal("take_over"), conflictMarketId: z.string() }),
]);

const countryInput = z.object({
  id: marketCountryIdFormat.schema.optional(),
  destinationCountryCode: countryCode,
  resolution: conflictResolution.optional(),
});

// Country rows missing from the input list are soft-deleted.
export const upsertMarket = {
  name: "upsertMarket" as const,
  input: z.object({
    marketId: marketIdFormat.schema.optional(),
    name: z.string().nullable().optional(),
    enabled: z.boolean().optional(),
    ...z.object(marketDefinitionWireFields).partial().shape,
    countries: z.array(countryInput),
  }),
  output: marketWithCountriesOutput.extend({
    variantsMissingHsCode: z.number().optional(),
  }),
};
